import api from '../../../api.js';
import conf from '../../conf.js';
import {loadUniverses, loadUniverse} from '../UniverseLoader/actions.js';
import {getUserMainUniverse} from '../../../shared/services/userService.js';

export const types = {
  START_LOADING: 'CurrentUser/startLoading',
  STOP_LOADING: 'CurrentUser/stopLoading',
  SET_CURRENT_USER: 'CurrentUser/set',
  SET_MEETING_SCHEDULED: 'CurrentUser/setMeetingScheduled',
  CURRENT_USER_NOT_CONNECTED: 'CurrentUser/notConnected',
  SET_CURRENT_FREELANCE: 'CurrentUser/setFreelance',
  REMOVE_CURRENT_USER: 'CurrentUser/remove',
  CANCEL_LOADER: 'CurrentUser/cancelLoader',
};

export function startLoading() {
  return {
    type: types.START_LOADING
  };
}

export function cancelLoader() {
  return {
    type: types.CANCEL_LOADER,
  };
}

export function stopLoading() {
  return {
    type: types.STOP_LOADING
  };
}

export function setCurrentUser(user) {
  let userRoles = 0;
  const roles = Object.values(conf.roles);
  if (user.roles) {
    user.roles.forEach((role) => {
      const index = roles.map((r) => r.name).indexOf(role);
      if (index !== -1) {
        userRoles |= roles[index].value;
      }
    });
  }
  user.isBusinessManager = (userRoles & conf.roles.businessManager.value) > 0;
  user.isSupport = (userRoles & conf.roles.support.value) > 0;
  user.isAdmin = (userRoles & conf.roles.admin.value) > 0;
  user.isInternal = user.isAdmin || user.isBusinessManager || user.isSupport;
  user.isMultiverse = user.universes && user.universes.length > 1;

  user.hasMeetingScheduled = !!user.meeting;

  return {
    type: types.SET_CURRENT_USER,
    user
  };
}

export function setMeetingScheduled(hasMeetingScheduled) {
  return {
    type: types.SET_MEETING_SCHEDULED,
    hasMeetingScheduled
  };
}

export function setCurrentFreelance(freelance) {
  return {
    type: types.SET_CURRENT_FREELANCE,
    freelance
  };
}

export function notConnected(e) {
  return {
    type: types.CURRENT_USER_NOT_CONNECTED,
    err: e,
  };
}

export function removeCurrentUser() {
  return {
    type: types.REMOVE_CURRENT_USER
  };
}

export function loadUser() {
  return async (dispatch, getState) => {
    dispatch(startLoading());

    await dispatch(loadUniverses());
    const {universes} = getState().universe;

    try {
      const user = (await api.users.getMe()).data;
      dispatch(setCurrentUser(user));
      dispatch(loadUniverse(getUserMainUniverse(user, universes)));
      if (user.freelance_id) {
        dispatch(loadFreelance(user.freelance_id));
      }
      return user;
    } catch (e) {
      dispatch(notConnected(e))
    } finally {
      dispatch(stopLoading());
    }
  }
}

export function loadFreelance(freelanceId) {
  return async (dispatch) => {
    dispatch(startLoading());
    try {
      const response = await api.freelances.getOne({freelance: freelanceId});
      dispatch(setCurrentFreelance(response.data));
      return response.data;
    } catch (e) {
      console.warn(e);
    } finally {
      dispatch(stopLoading());
    }
  };
}

export default {
  startLoading,
  stopLoading,
  setCurrentUser,
  setCurrentFreelance,
  notConnected,
  removeCurrentUser,
  loadUser,
  loadFreelance,
  cancelLoader,
};